import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';

export function FormItemList({ name, buttonLabel, placeholder, disabled }) {

  const message = "Please fill in or delete blank " + name;

  return (
    <>
      <Form.List name={name}>
        {(subFields, subOpt) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: 16,
            }}
          >
            {subFields.map((subField) => (
              <Space key={subField.key}>
                <Form.Item
                  {...subField}
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: message,
                    },
                  ]}
                  noStyle
                >
                  <Input
                    placeholder={placeholder}
                    // onChange={onchange}
                  />
                </Form.Item>
                {!disabled && (
                  <MinusCircleOutlined
                    onClick={() => {
                      subOpt.remove(subField.name);
                    }}
                  />
                )}
              </Space>
            ))}
            <Button type="dashed" onClick={() => subOpt.add()} block>
              {"+ " + buttonLabel}
            </Button>
          </div>
        )}
      </Form.List>
    </>
  )
};
